const style = {
  datetime: {
    '@media (min-width: 992px)': {
      display: `block`,
      textAlign: `center`
    },
    color: `#777`
  },
  time: {
    fontWeight: 600,
    fontSize: `13px`
  },
  date: {
    fontSize: `14px`,
    color: `#777`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Main/partials/ApplicationTable/style/date.js